<template>
  <v-layout justify-center>
    <v-flex xs12 sm10 md8 lg10>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
            <v-card-text>
                  <v-switch
                    v-model="showDetails"
                    label="Toon details"
                    color="primary"
                  ></v-switch>
              <table>
                <tr>
                  <th>periode</th>
                  <th>toegevoegd</th>
                  <th>verwijderd</th>
                  <th>correctie</th>
                  <th>statusovergangen</th>
                  <th>totaal bedrag</th>
                </tr>
                <tr v-for="item in statistics" v-bind:key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.uploadedAddresses }}</td>
                  <td>{{ item.removedAddresses }}</td>
                  <td>{{ item.removeAddressesCorrection }}</td>
                  <td>
                    <table>
                      <tr>
                        <th>van</th>
                        <th>naar</th>
                        <th>aantal</th> 
                        <th>prijs</th>
                        <th>totaal</th>
                      </tr>
                      <tr v-for="statusChange in filterDetais(item.transitions)" v-bind:key="statusChange.oldStatus + '->' + statusChange.newStatus">
                        <td v-bind:class="{ 'grey--text': !statusContainsDone(statusChange)}">{{ resolveLabel(statusChange.oldStatus) }}</td>
                        <td v-bind:class="{ 'grey--text': !statusContainsDone(statusChange)}">{{ resolveLabel(statusChange.newStatus) }}</td>
                        <td v-bind:class="{ 'grey--text': !statusContainsDone(statusChange)}">{{ statusChange.count }}</td>
                        <td v-bind:class="{ 'grey--text': !statusContainsDone(statusChange)}">&euro; {{ convertCentsToEuroNL(findPrice(statusChange, item.transitionToDonePriceInCents)) }}</td>
                        <td v-bind:class="{ 'grey--text': !statusContainsDone(statusChange)}">&euro; {{ convertCentsToEuroNL(findPrice(statusChange, item.transitionToDonePriceInCents)*statusChange.count) }}</td>
                      </tr>
                    </table>
                  </td>
                  <td>
                    <i class="grey--text">upload: &euro; {{ convertCentsToEuroNL(calculateTotals(item).upload) }} <br />
                    naar done: &euro; {{ convertCentsToEuroNL(calculateTotals(item).transitions) }} </i> <br />
                    <b> totaal: &euro; {{ convertCentsToEuroNL(calculateTotals(item).total) }} </b> 
                  </td>
                </tr>
              </table>
            </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<style lang="css" scoped>
td {
  border: 1px solid;
}
td, th {
  padding: 0px 10px 0px 10px;
}
</style>

<script>
import { adminService } from "@/services/admin/";
import { sharedStatusService } from "@/services/shared";

export default {
  data: () => ({
    statistics: [],
    showDetails: false,
  }),
  methods: {
    receiveStatistics() {
      adminService.getStatistics()
        .then(result => this.statistics = result.data)
        // eslint-disable-next-line
        .catch(() => console.log("Error!"));      
    },
    filterDetais(allStatuses) {
      return allStatuses.filter(s => this.showRow(s));
    },
    showRow(statusChange) {
      if (this.showDetails) {
        return true;
      }
      return this.statusContainsDone(statusChange);
    },
    statusContainsDone(statusChange) {
      return statusChange.newStatus === "DONE" || statusChange.oldStatus === "DONE";
    },
    isStatusChangeToDone(statusChange) {
      return statusChange.newStatus === "DONE" && statusChange.oldStatus !== "DONE";
    },
    isCorrectionStatusChange(statusChange) {
      return statusChange.newStatus !== "DONE" && statusChange.oldStatus === "DONE";
    },
    resolveLabel(status) {
      return sharedStatusService.resolveLabel(status);
    },
    findPrice(statusChange, price) {
      if (statusChange.newStatus === "DONE" && statusChange.oldStatus === "DONE") {
        return 0;
      }
      if (statusChange.newStatus === "DONE") {
        return price;
      }
      if (statusChange.oldStatus === "DONE") {
        return -price;
      }
      return 0;
    },
    calculateTotals(statisticsPeriod) {
      var subtotalUpload = statisticsPeriod.uploadedAddresses * statisticsPeriod.uploadPriceInCents;
      var subTotalTransitions = statisticsPeriod.transitions
        .filter(t => this.isStatusChangeToDone(t))
        .map(t => t.count)
        .reduce((acc, cur) => acc + cur * statisticsPeriod.transitionToDonePriceInCents, 0)

      var subTotalTransitionsCorrection = statisticsPeriod.transitions
        .filter(t => this.isCorrectionStatusChange(t))
        .map(t => t.count)
        .reduce((acc, cur) => acc + cur * statisticsPeriod.transitionToDonePriceInCents, 0)

      var total = subtotalUpload + subTotalTransitions - subTotalTransitionsCorrection;
      return {
        "upload": subtotalUpload,
        "transitions": subTotalTransitions - subTotalTransitionsCorrection,
        "total": total
      };
    },
    convertCentsToEuroNL(priceInCents) {
      return ((priceInCents / 100).toFixed(2) + "").replace(".", ",");
    }
  },
  created() {
    this.receiveStatistics();
  }
};
</script>
